import type { FormControl } from '@angular/forms';
import type { KundeStammdaten } from '../interfaces';
import type { ZurPersonFormCreator } from '../services/zur-person/zur-person-form.service';

export const prefillStammdaten = (
  zurPerson: Pick<ZurPersonFormCreator, 'naturalPersonForm' | 'addressForm'>,
  stammdaten: KundeStammdaten | null | undefined
): void => {
  if (!stammdaten) return;

  fillIfEmpty(zurPerson.naturalPersonForm.ctrls.geburtsdatum, stammdaten.geburtsdatum);
  fillIfEmpty(zurPerson.addressForm.ctrls.plz, stammdaten.plz);
  fillIfEmpty(zurPerson.addressForm.ctrls.ort, stammdaten.ort);
};

const fillIfEmpty = (ctrl: FormControl<string | null>, wert: string | null | undefined): void => {
  if (!wert || ctrl.value) return;

  ctrl.setValue(wert);
};
